<div id="notification-container">
  <div *ngIf="!mobile && display" class="container notification mt-5 mb-5"
       [ngClass]="{ 'is-danger' : error, 'is-success' : success}">
    <button *ngIf="!locked" class="delete" (click)="hideNotification()"></button>
    <span [innerHTML]="content"></span>
  </div>
  <div *ngIf="mobile && display" class="container is-fluid notification mt-5 mb-5"
       [ngClass]="{ 'is-danger' : error, 'is-success' : success}">
    <button *ngIf="!locked" class="delete" (click)="hideNotification()"></button>
    <span [innerHTML]="content"></span>
  </div>
</div>
